export default __webpack_public_path__ + "static/media/calls.8f469cc1.wav";